// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wt-8";
export var container = "_wt-0";
export var radioDot = "_wt-5";
export var radioDotSelected = "_wt-6";
export var row = "_wt-1";
export var rowFirst = "_wt-2";
export var rowLast = "_wt-3";
export var rowSelected = "_wt-4";
export var strikethrough = "_wt-7";